export default {
  'pages.login.success': 'Вход выполнен успешно!',
  'pages.login.failure': 'Ошибка входа, попробуйте снова!',
  'pages.login.username.placeholder': 'Имя пользователя',
  'pages.login.username.required': 'Пожалуйста, введите имя пользователя!',
  'pages.login.password.placeholder': 'Пароль',
  'pages.login.password.required': 'Пожалуйста, введите пароль!',
  'pages.login.rememberMe': 'Запомнить меня',
  'pages.login.forgotPassword': 'Забыли пароль?',
  'pages.login.forgotPasswordInfo':
    'Обратитесь к администратору для сброса пароля',
  'pages.login.submit': 'Войти',
  'pages.login.back': 'Назад',
  'pages.login.emailCheck.title': 'Подтверждение email',
  'pages.login.emailCheck.description':
    '6-значный код отправлен на {email}',
  'pages.login.emailCheck.sent':
    'Код подтверждения отправлен на ваш email',
  'pages.login.tfaCheck.title': 'Двухфакторная аутентификация',
  'pages.login.tfaCheck.description':
    'Введите 6-значный код из приложения-аутентификатора',
  'pages.login.verifyCode.submit': 'Подтвердить',
  'pages.login.verifyCode.invalid': 'Неверный код подтверждения',
  'pages.login.oidc.divider': 'Или продолжить с',
  'pages.login.oidc.continueWith': 'Продолжить с {provider}',
  'pages.login.oidc.authFailed': 'Ошибка входа OIDC',
  'pages.login.passkey.login': 'Войти с Passkey',
  'pages.login.passkey.failed': 'Ошибка проверки Passkey',
  'pages.devices.list': 'Список устройств',
  'pages.devices.os': 'ОС',
  'pages.devices.version': 'Версия клиента',
  'pages.devices.memory': 'Память',
  'pages.devices.lastOnline': 'Последний онлайн',
  'pages.devices.createdAt': 'Создан',
  'pages.devices.status': 'Статус',
  'pages.devices.user': 'Пользователь',
  'pages.devices.deviceGroup': 'Группа',
  'pages.devices.note': 'Примечание',
  'pages.devices.online': 'В сети',
  'pages.devices.offline': 'Не в сети',
  'pages.devices.days': 'дней',
  'pages.devices.hours': 'часов',
  'pages.devices.minutes': 'минут',
  'pages.devices.justNow': 'только что',
  'pages.devices.enable': 'Включить',
  'pages.devices.disable': 'Отключить',
  'pages.devices.enableSuccess': 'Устройство включено',
  'pages.devices.enableFailed': 'Не удалось включить устройство',
  'pages.devices.disableSuccess': 'Устройство отключено',
  'pages.devices.disableFailed': 'Не удалось отключить устройство',
  'pages.devices.deleteSuccess': 'Устройство удалено',
  'pages.devices.deleteFailed': 'Не удалось удалить устройство',
  'pages.devices.deleteConfirm': 'Вы уверены, что хотите удалить это устройство?',
  'pages.devices.block': 'Заблокировать',
  'pages.devices.blockConfirm':
    'Заблокировать это устройство? Его активные подключения будут принудительно завершены.',
  'pages.devices.blockTip':
    'Блокировка подключений: устройство не сможет подключаться к другим, активные сессии будут завершены',
  'pages.devices.blockSuccess': 'Устройство заблокировано',
  'pages.devices.blockFailed': 'Не удалось заблокировать устройство',
  'pages.devices.unblock': 'Разблокировать',
  'pages.devices.unblockConfirm': 'Разблокировать это устройство?',
  'pages.devices.unblockSuccess': 'Устройство разблокировано',
  'pages.devices.unblockFailed': 'Не удалось разблокировать устройство',
  'pages.devices.blockedTag': 'заблокирован',
  'pages.devices.autoRegistered': 'без агента',
  'pages.devices.source': 'Источник',
  'pages.devices.sourceHeartbeat': 'управляемое (heartbeat)',
  'pages.devices.blocked': 'Блокировка',
  'pages.devices.blockedYes': 'Заблокировано',
  'pages.devices.blockedNo': 'Не заблокировано',
  'pages.devices.deviceInfo': 'имя_пользователя@имя_устройства',
  'pages.devices.strategyInfo': 'Информация о стратегии',
  'pages.devices.device': 'Устройство',
  'pages.devices.strategy': 'Стратегия',
  'pages.devices.info': 'Информация',
  'pages.devices.statusNormal': 'Нормальный',
  'pages.devices.statusDisabled': 'Отключено',
  'pages.devices.onlineStatus': 'Статус онлайн',
  'pages.devices.deviceGroupSearchTip': 'Фильтр по имени группы устройств',
  'pages.devices.remove': 'Удалить',
  'pages.devices.removeFromGroupSuccess': 'Устройство удалено из группы',
  'pages.devices.removeFromGroupFailed': 'Не удалось удалить устройство из группы',
  'pages.devices.removeFromGroupConfirm':
    'Вы уверены, что хотите удалить это устройство из группы?',
  'pages.devices.batchRemove': 'Групповое удаление',
  'pages.devices.batchRemoveFromGroupSuccess':
    'Успешно удалено {count} устройств(а) из группы',
  'pages.devices.batchRemoveFromGroupFailed':
    'Не удалось удалить устройства из группы',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Вы уверены, что хотите удалить выбранные устройства из группы?',
  'pages.devices.batchEnable': 'Групповое включение',
  'pages.devices.batchDisable': 'Групповое отключение',
  'pages.devices.batchEnableConfirm':
    'Вы уверены, что хотите включить выбранные устройства?',
  'pages.devices.batchDisableConfirm':
    'Вы уверены, что хотите отключить выбранные устройства?',
  'pages.devices.batchEnableSuccess': 'Успешно включено {count} устройств(а)',
  'pages.devices.batchEnableFailed': 'Не удалось включить устройства',
  'pages.devices.batchEnablePartialFailed':
    'Успешно включено {success} устройств(а), {failed} с ошибкой',
  'pages.devices.batchDisableSuccess':
    'Успешно отключено {count} устройств(а)',
  'pages.devices.batchDisableFailed': 'Не удалось отключить устройства',
  'pages.devices.batchDisablePartialFailed':
    'Успешно отключено {success} устройств(а), {failed} с ошибкой',
  'pages.devices.edit': 'Редактировать устройство',
  'pages.devices.updateSuccess': 'Устройство обновлено',
  'pages.devices.updateFailed': 'Не удалось обновить устройство',
  'pages.devices.selectUser': 'Выберите пользователя',
  'pages.devices.selectDeviceGroup': 'Выберите группу устройств',
  'pages.devices.selectStrategy': 'Выберите стратегию',
  'pages.addressBook.name': 'Имя',
  'pages.addressBook.note': 'Примечание',
  'pages.addressBook.shared': 'Общие адресные книги',
  'pages.addressBook.create': 'Создать адресную книгу',
  'pages.addressBook.edit': 'Редактировать адресную книгу',
  'pages.addressBook.personal': 'Личная адресная книга',
  'pages.addressBook.currentAddressBook': 'Адресная книга',
  'pages.addressBook.myAddressBook': 'Моя адресная книга',
  'pages.addressBook.loadFailed': 'Не удалось загрузить адресные книги',
  'pages.addressBook.addPeer': 'Добавить по ID',
  'pages.addressBook.addTag': 'Добавить тег',
  'pages.addressBook.tagName': 'Имя тега',
  'pages.addressBook.tagAdded': 'Тег добавлен',
  'pages.addressBook.tagAddFailed': 'Не удалось добавить тег',
  'pages.addressBook.tagDeleted': 'Тег удалён',
  'pages.addressBook.tagDeleteFailed': 'Не удалось удалить тег',
  'pages.addressBook.deleteTagConfirm': 'Вы уверены, что хотите удалить этот тег?',
  'pages.addressBook.tagModeUnion': 'Любой',
  'pages.addressBook.tagModeIntersection': 'Все',
  'pages.addressBook.importDevices': 'Импорт из устройств',
  'pages.addressBook.importSuccess': 'Успешно импортировано {count} устройств(а)',
  'pages.addressBook.importPartialFailed': 'Не удалось импортировать {count} устройств(а)',
  'pages.addressBook.createSuccess': 'Адресная книга создана',
  'pages.addressBook.createFailed': 'Не удалось создать адресную книгу',
  'pages.addressBook.updateSuccess': 'Адресная книга обновлена',
  'pages.addressBook.updateFailed': 'Не удалось обновить адресную книгу',
  'pages.addressBook.deleteSuccess': 'Адресная книга удалена',
  'pages.addressBook.deleteFailed': 'Не удалось удалить адресную книгу',
  'pages.addressBook.deleteConfirm':
    'Вы уверены, что хотите удалить эту адресную книгу?',
  'pages.addressBook.batchDeleteConfirm':
    'Вы уверены, что хотите удалить выбранные адресные книги?',
  'pages.addressBook.device': 'Устройство',
  'pages.addressBook.alias': 'Псевдоним',
  'pages.addressBook.tags': 'Теги',
  'pages.addressBook.peerAdded': 'Контакт добавлен',
  'pages.addressBook.peerAddFailed': 'Не удалось добавить контакт',
  'pages.addressBook.peerDeleted': 'Контакт удалён',
  'pages.addressBook.peerDeleteFailed': 'Не удалось удалить контакт',
  'pages.addressBook.deletePeerConfirm': 'Вы уверены, что хотите удалить этот контакт?',
  'pages.addressBook.import': 'Импорт из устройств',
  'pages.addressBook.recycleBin': 'Корзина',
  'pages.deviceGroups.list': 'Группы устройств',
  'pages.deviceGroups.name': 'Имя',
  'pages.deviceGroups.note': 'Примечание',
  'pages.deviceGroups.create': 'Создать группу устройств',
  'pages.deviceGroups.edit': 'Редактировать группу устройств',
  'pages.deviceGroups.createSuccess': 'Группа устройств создана',
  'pages.deviceGroups.createFailed': 'Не удалось создать группу устройств',
  'pages.deviceGroups.updateSuccess': 'Группа устройств обновлена',
  'pages.deviceGroups.updateFailed': 'Не удалось обновить группу устройств',
  'pages.deviceGroups.deleteSuccess': 'Группа устройств удалена',
  'pages.deviceGroups.deleteFailed': 'Не удалось удалить группу устройств',
  'pages.deviceGroups.deleteConfirm':
    'Вы уверены, что хотите удалить эту группу устройств?',
  'pages.deviceGroups.import': 'Импорт',
  'pages.deviceGroups.importDevices': 'Импорт устройств',
  'pages.deviceGroups.importSuccess': 'Успешно импортировано {count} устройств(а)',
  'pages.deviceGroups.importFailed': 'Не удалось импортировать устройства',
  'pages.users.list': 'Список пользователей',
  'pages.users.name': 'Имя',
  'pages.users.displayName': 'Отображаемое имя',
  'pages.users.email': 'Email',
  'pages.users.note': 'Примечание',
  'pages.users.status': 'Статус',
  'pages.users.create': 'Создать пользователя',
  'pages.users.enable': 'Включить',
  'pages.users.disable': 'Отключить',
  'pages.users.enableSuccess': 'Пользователь включён',
  'pages.users.enableFailed': 'Не удалось включить пользователя',
  'pages.users.disableSuccess': 'Пользователь отключён',
  'pages.users.disableFailed': 'Не удалось отключить пользователя',
  'pages.users.createSuccess': 'Пользователь создан',
  'pages.users.createFailed': 'Не удалось создать пользователя',
  'pages.users.deleteSuccess': 'Пользователь удалён',
  'pages.users.deleteFailed': 'Не удалось удалить пользователя',
  'pages.users.deleteConfirm': 'Вы уверены, что хотите удалить этого пользователя?',
  'pages.audits.conn': 'Журнал подключений',
  'pages.audits.file': 'Журнал передачи файлов',
  'pages.audits.alarm': 'Журнал тревог',
  'pages.audits.console': 'Журнал консоли',
  'pages.audits.requestedAt': 'Запрошено в',
  'pages.audits.establishedAt': 'Установлено в',
  'pages.audits.closedAt': 'Закрыто в',
  'pages.audits.from': 'От',
  'pages.audits.fromName': 'Имя отправителя',
  'pages.audits.to': 'К',
  'pages.audits.toName': 'Имя получателя',
  'pages.audits.action': 'Действие',
  'pages.audits.time': 'Время',
  'pages.audits.alarmType': 'Тип тревоги',
  'pages.audits.user': 'Пользователь',
  'pages.audits.detail': 'Детали',
  'pages.audits.type': 'Тип',
  'pages.audits.connType.remoteDesktop': 'Удалённый рабочий стол',
  'pages.audits.connType.fileTransfer': 'Передача файлов',
  'pages.audits.connType.portTransfer': 'Пересылка портов',
  'pages.audits.connType.viewCamera': 'Просмотр камеры',
  'pages.audits.connType.terminal': 'Терминал',
  'pages.audits.connType.notLoggedIn': 'Не выполнен вход',
  'pages.audits.active': 'активно',
  'pages.audits.duration': 'Длительность',
  'pages.audits.note': 'Примечание',
  'pages.audits.disconnect': 'Отключить',
  'pages.audits.disconnectSuccess': 'Успешно отключено!',
  'pages.audits.disconnectFailed': 'Не удалось отключить!',
  'pages.audits.disconnectConfirmTitle': 'Подтверждение операции',
  'pages.audits.disconnectConfirmTip':
    'Вы уверены, что хотите отключить это устройство?',
  'pages.audits.updateSuccess': 'Обновление выполнено успешно',
  'pages.audits.updateFailed': 'Ошибка обновления, попробуйте снова!',
  'pages.audits.exportCSV': 'Экспорт CSV',
  'pages.audits.noDataToExport': 'Нет данных для экспорта',
  'pages.audits.exportSuccess': 'Экспорт выполнен успешно',
  'pages.audits.exportFailed': 'Ошибка экспорта',
  'pages.audits.exportConfirmTitle': 'Экспорт CSV',
  'pages.audits.exportConfirmContent': 'Экспорт до 1000 записей. Продолжить?',
  'pages.audits.remote': 'Удалённый',
  'pages.audits.local': 'Локальный',
  'pages.audits.direction': 'Направление',
  'pages.audits.files': 'Файлы',
  'pages.audits.remoteTip': 'Удалённо управляемый компьютер или терминал',
  'pages.audits.remoteSearchTip': 'Поиск по ID удалённого устройства (нечёткое совпадение)',
  'pages.audits.remotePlaceholder': 'Введите ID удалённого устройства',
  'pages.audits.pathTip': 'Путь к удалённому устройству',
  'pages.audits.exportCsvTip': 'Экспорт до 1000 записей за раз',
  'pages.audits.limitedTip': 'Показать 10 самых больших файлов по размеру',
  'pages.audits.startTime': 'Время начала',
  'pages.audits.endTime': 'Время окончания',
  'pages.audits.alarmType.ipWhitelist': 'IP не в белом списке',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'Превышено 30 неудачных попыток с одного IP',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'Более 6 попыток за 1 минуту',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'Превышен лимит попыток IPv6 префикса',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Вход в ОС терминала заблокирован',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Превышен лимит одновременных входов в ОС терминала',
  'pages.common.action': 'Действие',
  'pages.common.delete': 'Удалить',
  'pages.common.edit': 'Редактировать',
  'pages.common.batchDelete': 'Групповое удаление',
  'pages.common.download': 'Скачать',
  'pages.common.more': 'Ещё',
  'pages.404.subTitle': 'Извините, запрашиваемая страница не существует',
  'pages.404.buttonText': 'На главную',
  'pages.customClients.list': 'Список пользовательских клиентов',
  'pages.customClients.name': 'Имя клиента',
  'pages.customClients.createdAt': 'Дата создания',
  'pages.customClients.create': 'Создать пользовательского клиента',
  'pages.customClients.edit': 'Редактировать пользовательского клиента',
  'pages.customClients.deleteConfirm':
    'Вы уверены, что хотите удалить этого клиента?',
  'pages.customClients.createSuccess': 'Пользовательский клиент создан',
  'pages.customClients.createFailed': 'Не удалось создать пользовательского клиента',
  'pages.customClients.updateSuccess': 'Пользовательский клиент обновлён',
  'pages.customClients.updateFailed': 'Не удалось обновить пользовательского клиента',
  'pages.customClients.deleteSuccess': 'Пользовательский клиент удалён',
  'pages.customClients.deleteFailed': 'Не удалось удалить пользовательского клиента',
  'pages.customClients.downloadFailed': 'Не удалось скачать клиента',
  'pages.userGroups.list': 'Список групп пользователей',
  'pages.userGroups.name': 'Имя группы',
  'pages.userGroups.note': 'Примечание',
  'pages.userGroups.userCount': 'Количество пользователей',
  'pages.userGroups.create': 'Создать группу пользователей',
  'pages.userGroups.edit': 'Редактировать группу пользователей',
  'pages.userGroups.deleteConfirm': 'Вы уверены, что хотите удалить эту группу пользователей?',
  'pages.userGroups.createSuccess': 'Группа пользователей создана',
  'pages.userGroups.createFailed': 'Не удалось создать группу пользователей',
  'pages.userGroups.updateSuccess': 'Группа пользователей обновлена',
  'pages.userGroups.updateFailed': 'Не удалось обновить группу пользователей',
  'pages.userGroups.deleteSuccess': 'Группа пользователей удалена',
  'pages.userGroups.deleteFailed': 'Не удалось удалить группу пользователей',
  'pages.userGroups.loadFailed': 'Не удалось загрузить группы пользователей',
  'pages.userGroups.default': 'По умолчанию',
  'pages.userGroups.members': 'Участники',
  'pages.userGroups.membersTitle': 'Участники {name}',
  'pages.userGroups.currentMembers': 'Текущие участники',
  'pages.userGroups.addUsers': 'Добавить пользователей',
  'pages.userGroups.destination': 'Целевая группа',
  'pages.userGroups.selectDestination': 'Выберите целевую группу',
  'pages.userGroups.moveSelected': 'Переместить выбранных',
  'pages.userGroups.addSelected': 'Добавить выбранных пользователей',
  'pages.userGroups.membersUpdated': 'Обновлено {count} пользователей(я)',
  'pages.userGroups.membersUpdateFailed': 'Не удалось обновить участников группы',
  'pages.users.userGroup': 'Группа пользователей',
  'pages.users.selectUserGroup': 'Выберите группу пользователей',
  'pages.addressBook.groupAccess': 'Доступ группы',
  'pages.addressBook.groupAccessTitle': 'Доступ группы {name}',
  'pages.addressBook.userGroup': 'Группа пользователей',
  'pages.addressBook.permission': 'Разрешение',
  'pages.addressBook.permissionRead': 'Только чтение',
  'pages.addressBook.permissionReadWrite': 'Чтение и запись',
  'pages.addressBook.permissionFull': 'Полный доступ',
  'pages.addressBook.addGroupAccess': 'Добавить доступ группы',
  'pages.addressBook.groupAccessLoadFailed': 'Не удалось загрузить доступ группы',
  'pages.addressBook.groupAccessAdded': 'Доступ группы добавлен',
  'pages.addressBook.groupAccessAddFailed': 'Не удалось добавить доступ группы',
  'pages.addressBook.groupAccessUpdated': 'Доступ группы обновлён',
  'pages.addressBook.groupAccessUpdateFailed': 'Не удалось обновить доступ группы',
  'pages.addressBook.groupAccessDeleted': 'Доступ группы удалён',
  'pages.addressBook.groupAccessDeleteFailed': 'Не удалось удалить доступ группы',
  'pages.addressBook.groupAccessDeleteConfirm': 'Удалить этот доступ группы?',
  'pages.addressBook.shareAccess': 'Поделиться',
  'pages.addressBook.accessTitle': '{name} - Управление доступом',
  'pages.addressBook.shareType': 'Тип доступа',
  'pages.addressBook.shareTarget': 'Цель',
  'pages.addressBook.shareTypeEveryone': 'Все',
  'pages.addressBook.shareTypeUser': 'Пользователь',
  'pages.addressBook.shareTypeGroup': 'Группа пользователей',
  'pages.addressBook.selectUser': 'Выберите пользователя',
  'pages.addressBook.selectUserPlaceholder': 'Поиск по имени или email',
  'pages.addressBook.everyoneHint':
    'Все пользователи будут иметь доступ к этой адресной книге',
  'pages.addressBook.allUsers': 'Все пользователи',
  'pages.addressBook.addAccess': 'Добавить доступ',
  'pages.addressBook.accessLoadFailed': 'Не удалось загрузить правила доступа',
  'pages.addressBook.accessAdded': 'Правило доступа добавлено',
  'pages.addressBook.accessAddFailed': 'Не удалось добавить правило доступа',
  'pages.addressBook.accessUpdated': 'Правило доступа обновлено',
  'pages.addressBook.accessUpdateFailed': 'Не удалось обновить правило доступа',
  'pages.addressBook.accessDeleted': 'Правило доступа удалено',
  'pages.addressBook.accessDeleteFailed': 'Не удалось удалить правило доступа',
  'pages.addressBook.accessDeleteConfirm': 'Удалить это правило доступа?',
  'pages.roles.list': 'Список ролей',
  'pages.roles.name': 'Имя роли',
  'pages.roles.note': 'Примечание',
  'pages.roles.permissions': 'Разрешения',
  'pages.roles.permissionsInfo': 'Количество назначенных разрешений',
  'pages.roles.create': 'Создать роль',
  'pages.roles.edit': 'Редактировать роль',
  'pages.roles.deleteConfirm': 'Вы уверены, что хотите удалить эту роль?',
  'pages.roles.selectPermissions': 'Выберите разрешения',
  'pages.roles.createSuccess': 'Роль успешно создана',
  'pages.roles.createFailed': 'Не удалось создать роль',
  'pages.roles.updateSuccess': 'Роль успешно обновлена',
  'pages.roles.updateFailed': 'Не удалось обновить роль',
  'pages.roles.deleteSuccess': 'Роль успешно удалена',
  'pages.roles.deleteFailed': 'Не удалось удалить роль',
  'pages.settings.title': 'Настройки системы',
  'pages.settings.save': 'Сохранить настройки',
  'pages.settings.general': 'Общие настройки',
  'pages.settings.siteName': 'Название сайта',
  'pages.settings.platformName': 'Название платформы',
  'pages.settings.platformNameTip':
    'Отображается в заголовке вкладки и шапке админки',
  'pages.settings.logoUrl': 'Логотип',
  'pages.settings.logoUrlTip': 'Изображение логотипа в шапке админки',
  'pages.settings.logoUpload': 'Загрузить логотип',
  'pages.settings.logoUploadSuccess': 'Логотип загружен',
  'pages.settings.logoUploadFailed': 'Не удалось загрузить логотип',
  'pages.settings.logoClear': 'Удалить логотип',
  'pages.settings.logoClearConfirm': 'Удалить текущий логотип?',
  'pages.settings.logoClearSuccess': 'Логотип удалён',
  'pages.settings.logoClearFailed': 'Не удалось удалить логотип',
  'pages.settings.logoFileTooLarge': 'Размер файла не должен превышать 2 МБ',
  'pages.settings.logoInvalidFormat':
    'Поддерживаются только PNG, JPEG, WebP, SVG',
  'pages.settings.footerText': 'Текст в подвале',
  'pages.settings.footerTextTip': 'Текст в нижней части админки',
  'pages.settings.relay': 'Реле',
  'pages.settings.relay.description':
    'Релей-серверы (hbbr), которые hbbs анонсирует клиентам по умолчанию. Клиенты без явно указанного релея используют их и автоматически выбирают самый быстрый. Формат: host или host:порт (порт по умолчанию 21117).',
  'pages.settings.relay.empty': 'Реле не настроены',
  'pages.settings.relay.add': 'Добавить',
  'pages.settings.relay.hostRequired': 'Введите адрес релея',
  'pages.settings.relay.alreadyExists': 'Такой релей уже добавлен',
  'pages.settings.relay.fetchFailed': 'Не удалось загрузить список релеев',
  'pages.settings.relay.saveSuccess':
    'Реле сохранены. hbbs будет анонсировать их клиентам.',
  'pages.settings.relay.saveFailed': 'Не удалось сохранить реле',
  'pages.settings.relay.online': 'в сети',
  'pages.settings.relay.offline': 'недоступен',
  'pages.settings.relay.clients': 'клиентов',
  'pages.settings.relay.remoteCountUnavailable':
    'Мониторинг недоступен: на удалённом сервере не установлен агент релея',
  'pages.settings.relay.totalActive': 'Активных клиентов: {total}',
  'pages.settings.relay.checkedAt': 'Обновлено {time}',
  'pages.settings.relay.refresh': 'Обновить',
  'pages.settings.clientUpdate': 'Обновление клиентов',
  'pages.settings.clientUpdate.description':
    'Команда на обновление передаётся только выбранным устройствам в ответе heartbeat. В поле «Новая версия» укажите версию в формате 1.4.9 — по ней определяется актуальность устройств. В поле URL укажите прямую ссылку на установщик.',
  'pages.settings.clientUpdate.fetchFailed':
    'Не удалось загрузить настройки обновления клиентов',
  'pages.settings.clientUpdate.targetVersionRequired':
    'Укажите новую версию, например 1.4.9',
  'pages.settings.clientUpdate.targetVersionInvalid':
    'Неверный формат версии. Укажите в виде 1.4.9 (опционально 1.4.9-2)',
  'pages.settings.clientUpdate.urlRequired': 'Укажите URL установщика',
  'pages.settings.clientUpdate.targetDevicesRequired':
    'Выберите хотя бы одно устройство для обновления',
  'pages.settings.clientUpdate.saveSuccess':
    'Настройки сохранены. Команда будет передана клиентам при следующем heartbeat',
  'pages.settings.clientUpdate.saveFailed': 'Не удалось сохранить настройки',
  'pages.settings.clientUpdate.clearSuccess': 'Обновление клиентов отключено',
  'pages.settings.clientUpdate.clearFailed':
    'Не удалось отключить обновление клиентов',
  'pages.settings.clientUpdate.refreshed': 'Данные обновлены',
  'pages.settings.clientUpdate.total': 'Всего устройств',
  'pages.settings.clientUpdate.outdated': 'Устаревшие (ниже новой версии)',
  'pages.settings.clientUpdate.matching': 'На новой версии',
  'pages.settings.clientUpdate.unknown': 'Неизвестная версия',
  'pages.settings.clientUpdate.enabled': 'Включить обновление клиентов',
  'pages.settings.clientUpdate.version': 'Версия (отображаемая клиенту)',
  'pages.settings.clientUpdate.versionTip':
    'Например 1.4.9 — показывается клиенту в уведомлении о новой версии',
  'pages.settings.clientUpdate.targetVersion': 'Новая версия',
  'pages.settings.clientUpdate.targetVersionTip':
    'Версия в формате 1.4.9 (опционально 1.4.9-2). Устройства с версией ниже считаются устаревшими',
  'pages.settings.clientUpdate.url': 'URL установщика',
  'pages.settings.clientUpdate.message': 'Сообщение клиенту',
  'pages.settings.clientUpdate.messagePlaceholder':
    'Например: Доступна новая версия клиента',
  'pages.settings.clientUpdate.targetDevices': 'Точечный выбор устройств',
  'pages.settings.clientUpdate.targetDevicesTip':
    'Команда уходит только выбранным устройствам. Автоматическая рассылка всем не выполняется',
  'pages.settings.clientUpdate.targetDevicesPlaceholder':
    'Выберите устройства для обновления',
  'pages.settings.clientUpdate.save': 'Сохранить',
  'pages.settings.clientUpdate.disable': 'Отключить обновление',
  'pages.settings.clientUpdate.refresh': 'Обновить',
  'pages.settings.adminEmail': 'Email администратора',
  'pages.settings.language': 'Язык по умолчанию',
  'pages.settings.security': 'Настройки безопасности',
  'pages.settings.enable2FA': 'Включить двухфакторную аутентификацию',
  'pages.settings.sessionTimeout': 'Тайм-аут сессии (минуты)',
  'pages.settings.maxLoginAttempts': 'Максимум попыток входа',
  'pages.settings.advanced': 'Расширенные настройки',
  'pages.settings.logLevel': 'Уровень логирования',
  'pages.settings.enableDebugMode': 'Включить режим отладки',
  'pages.settings.fetchFailed': 'Не удалось загрузить настройки',
  'pages.settings.saveSuccess': 'Настройки успешно сохранены',
  'pages.settings.saveFailed': 'Не удалось сохранить настройки',
  'pages.strategies.list': 'Список стратегий',
  'pages.strategies.name': 'Имя стратегии',
  'pages.strategies.note': 'Примечание',
  'pages.strategies.status': 'Статус',
  'pages.strategies.create': 'Создать стратегию',
  'pages.strategies.edit': 'Редактировать стратегию',
  'pages.strategies.deleteConfirm': 'Вы уверены, что хотите удалить эту стратегию?',
  'pages.strategies.createSuccess': 'Стратегия создана',
  'pages.strategies.createFailed': 'Не удалось создать стратегию',
  'pages.strategies.updateSuccess': 'Стратегия обновлена',
  'pages.strategies.updateFailed': 'Не удалось обновить стратегию',
  'pages.strategies.deleteSuccess': 'Стратегия удалена',
  'pages.strategies.deleteFailed': 'Не удалось удалить стратегию',
  'pages.strategies.enterName': 'Введите имя стратегии',
  'pages.strategies.configSummary': 'Конфигурация',
  'pages.strategies.configCount': '{modified}/{total} изменено',
  'pages.strategies.modifiedAt': 'Изменено в',
  'pages.strategies.createdAt': 'Создано в',
  'pages.strategies.configOptions': 'Параметры конфигурации',
  'pages.strategies.defaultLabel': 'По умолчанию',
  'pages.strategies.defaultValue': 'По умолчанию: {value}',
  'pages.strategies.resetToDefault': 'Сбросить на умолчание',
  'pages.strategies.modifiedSummary': '{count} конфигураций изменено',
  'pages.strategies.resetAll': 'Сбросить всё',
  'pages.strategies.assign': 'Назначить',
  'pages.strategies.assignManagement': 'Управление назначениями',
  'pages.strategies.assignDevice': 'Устройство',
  'pages.strategies.assignUser': 'Пользователь',
  'pages.strategies.assignDeviceGroup': 'Группа устройств',
  'pages.strategies.assignedTargets': 'Назначенные цели',
  'pages.strategies.noAssigned': 'Нет назначенных целей',
  'pages.strategies.addAssignment': 'Добавить назначение',
  'pages.strategies.selectTarget': 'Выберите цель',
  'pages.strategies.assignSuccess': 'Стратегия успешно назначена',
  'pages.strategies.assignFailed': 'Не удалось назначить стратегию',
  'pages.strategies.assignPartialFailed':
    'Назначено {success} целей, {failed} с ошибкой: {errors}',
  'pages.strategies.unassignSuccess': 'Стратегия успешно отменена',
  'pages.strategies.unassignFailed': 'Не удалось отменить стратегию',
  'pages.strategies.unassignConfirm': 'Отменить назначение для этой цели?',
  'pages.strategies.fetchDetailFailed': 'Не удалось получить детали стратегии',
  'pages.strategies.updatedAt': 'Обновлено в',
  'pages.strategies.category.connection': 'Подключение и доступ',
  'pages.strategies.category.security': 'Безопасность и аутентификация',
  'pages.strategies.category.display': 'Дисплей и интерфейс',
  'pages.strategies.category.av': 'Аудио/Видео и кодек',
  'pages.strategies.category.file': 'Файлы и буфер обмена',
  'pages.strategies.category.advanced': 'Расширенные',
  'pages.strategies.category.floating': 'Плавающее окно',
  'pages.strategies.category.privacy': 'Конфиденциальность и запись',
  'pages.strategies.category.hide': 'Скрытие интерфейса',
  'pages.users.inviteSuccess': 'Приглашение отправлено',
  'pages.users.inviteFailed': 'Не удалось отправить приглашение',
  'pages.users.active': 'Активен',
  'pages.users.disabled': 'Отключён',
  'pages.users.unverified': 'Не подтверждён',
  'pages.users.roles': 'Роли',
  'pages.users.rolesInfo': 'Роли и разрешения пользователя',
  'pages.users.strategy': 'Стратегия',
  'pages.users.strategyInfo': 'Стратегия подключения для пользователя',
  'pages.users.group': 'Группа',
  'pages.users.groupInfo': 'Назначение группы пользователей',
  'pages.users.groupName': 'Группа устройств',
  'pages.users.invite': 'Пригласить пользователя',
  'pages.users.password': 'Пароль',
  'pages.users.isAdmin': 'Администратор',
  'pages.users.normalUser': 'Обычный',
  'pages.users.statusInfo': 'Статус аккаунта пользователя',
  'pages.users.edit': 'Редактировать пользователя',
  'pages.users.updateSuccess': 'Пользователь обновлён',
  'pages.users.updateFailed': 'Не удалось обновить пользователя',
  'pages.users.security': 'Безопасность',
  'pages.users.securitySettings': 'Настройки безопасности',
  'pages.users.securityUpdateSuccess': 'Настройки безопасности обновлены',
  'pages.users.securityUpdateFailed': 'Не удалось обновить настройки безопасности',
  'pages.users.tfaEnforce': 'Обязательная двухфакторная аутентификация',
  'pages.users.emailVerification': 'Требовать подтверждение email',
  'pages.users.forceLogout': 'Выйти',
  'pages.users.forceLogoutSuccess': 'Принудительный выход выполнен',
  'pages.users.forceLogoutFailed': 'Не удалось принудительно выйти',
  'pages.users.thirdAuthType': 'Тип аутентификации',
  'pages.users.createdAt': 'Дата создания',
  'pages.users.batchEnable': 'Групповое включение',
  'pages.users.batchDisable': 'Групповое отключение',
  'pages.users.batchForceLogout': 'Групповой принудительный выход',
  'pages.users.batchEnableConfirm': 'Вы уверены, что хотите включить выбранных пользователей?',
  'pages.users.batchDisableConfirm': 'Вы уверены, что хотите отключить выбранных пользователей?',
  'pages.users.batchForceLogoutConfirm':
    'Вы уверены, что хотите принудительно выйти из выбранных пользователей?',
  'pages.users.batchEnableSuccess': 'Успешно включено {count} пользователей(я)',
  'pages.users.batchEnableFailed': 'Не удалось включить пользователей',
  'pages.users.batchEnablePartialFailed':
    'Успешно включено {success} пользователей(я), {failed} с ошибкой',
  'pages.users.batchDisableSuccess': 'Успешно отключено {count} пользователей(я)',
  'pages.users.batchDisableFailed': 'Не удалось отключить пользователей',
  'pages.users.batchDisablePartialFailed':
    'Успешно отключено {success} пользователей(я), {failed} с ошибкой',
  'pages.users.batchForceLogoutSuccess': 'Групповой принудительный выход выполнен',
  'pages.users.batchForceLogoutFailed': 'Не удалось выполнить принудительный выход',
  'pages.dashboard.totalUsers': 'Всего пользователей',
  'pages.dashboard.activeUsers': 'Активные пользователи',
  'pages.dashboard.totalDevices': 'Всего устройств',
  'pages.dashboard.onlineDevices': 'Устройства в сети',
  'pages.dashboard.offlineDevices': 'Устройства не в сети',
  'pages.dashboard.todayConnections': 'Подключений сегодня',
  'pages.dashboard.activeConnections': 'Активные подключения',
  'pages.dashboard.edit': 'Настроить',
  'pages.dashboard.editDone': 'Готово',
  'pages.dashboard.moduleManager': 'Отображение модулей',
  'pages.dashboard.moduleReset': 'Сбросить',
  'pages.dashboard.module.overview': 'Обзор',
  'pages.dashboard.module.resource': 'Ресурсы и анализ',
  'pages.dashboard.module.operation': 'Операционный анализ',
  'pages.dashboard.module.systemStatus': 'Статус системы',
  'pages.dashboard.module.trends': 'Графики',
  'pages.dashboard.module.activeConnections': 'Активные подключения',
  'pages.dashboard.module.recentEvents': 'Последние события',
  'pages.dashboard.avgDuration': 'Средняя длительность',
  'pages.dashboard.totalAlarms': 'Всего тревог',
  'pages.dashboard.criticalAlarms': 'Критические тревоги',
  'pages.dashboard.userDistribution': 'Распределение пользователей',
  'pages.dashboard.adminUsers': 'Администраторы',
  'pages.dashboard.normalUsers': 'Обычные пользователи',
  'pages.dashboard.deviceDistribution': 'Распределение устройств',
  'pages.dashboard.connectionAnalysis': 'Анализ подключений',
  'pages.dashboard.successRate': 'Процент успеха',
  'pages.dashboard.failureCount': 'Количество ошибок',
  'pages.dashboard.totalDuration': 'Общая длительность',
  'pages.dashboard.fileTransfer': 'Передача файлов',
  'pages.dashboard.transferredToday': 'Передано сегодня',
  'pages.dashboard.totalSize': 'Общий размер',
  'pages.dashboard.uploadCount': 'Количество загрузок',
  'pages.dashboard.downloadCount': 'Количество скачиваний',
  'pages.dashboard.systemStatus': 'Состояние системы',
  'pages.dashboard.uptime': 'Время работы',
  'pages.dashboard.trendData': 'Данные трендов',
  'pages.dashboard.connectionTrend': 'Тренд подключений',
  'pages.dashboard.userActiveTrend': 'Тренд активности пользователей',
  'pages.dashboard.alarmTrend': 'Тренд тревог',
  'pages.dashboard.recentEvents': 'Последние события',
  'pages.dashboard.user': 'Пользователь',
  'pages.dashboard.device': 'Устройство',
  'pages.dashboard.duration': 'Длительность',
  'pages.dashboard.minutes': 'мин',
  'pages.dashboard.startTime': 'Время начала',
  'pages.dashboard.eventType': 'Тип',
  'pages.dashboard.action': 'Действие',
  'pages.dashboard.target': 'Цель',
  'pages.dashboard.status': 'Статус',
  'pages.dashboard.time': 'Время',
  'pages.dashboard.event.connection': 'Подключение',
  'pages.dashboard.event.file': 'Файл',
  'pages.dashboard.event.established': 'Установлено',
  'pages.dashboard.event.close': 'Закрыто',
  'pages.dashboard.event.send': 'Отправка',
  'pages.dashboard.event.receive': 'Получение',
  'pages.dashboard.event.success': 'Успешно',
  'pages.dashboard.event.failed': 'Ошибка',
  'pages.dashboard.event.warning': 'Предупреждение',
  'pages.dashboard.event.unknown': 'Неизвестно',
  'pages.common.pleaseEnterName': 'Пожалуйста, введите имя',
  'pages.common.pleaseEnterId': 'Пожалуйста, введите ID',
  'pages.common.pleaseEnterTagName': 'Пожалуйста, введите имя тега',
  'pages.common.pleaseEnterUsername': 'Пожалуйста, введите имя пользователя',
  'pages.common.pleaseEnterEmail': 'Пожалуйста, введите email',
  'pages.common.pleaseEnterValidEmail': 'Пожалуйста, введите корректный email',
  'pages.common.pleaseEnterPassword': 'Пожалуйста, введите пароль',
  'pages.common.pleaseEnterRoleName': 'Пожалуйста, введите имя роли',
  'pages.common.id': 'ID',
  'pages.dashboard.min': 'мин',
  'pages.dashboard.cpu': 'ЦП',
  'pages.dashboard.memory': 'Память',
  'pages.dashboard.disk': 'Диск',
  'pages.dashboard.inactive': 'Неактивен',
  'pages.dashboard.onlineRate': 'Процент в сети',
  'pages.dashboard.connectionCount': 'Количество',
  'pages.dashboard.newUsers': 'Новые пользователи',
  'pages.dashboard.7days': '7 дней',
  'pages.dashboard.30days': '30 дней',
  'pages.dashboard.90days': '90 дней',
  'pages.dashboard.noData': 'Нет данных',
  'pages.dashboard.resourceDistribution': 'Распределение ресурсов',
  'pages.dashboard.operationAnalysis': 'Анализ операций',
  'pages.dashboard.module.typeDistribution': 'Типы подключений',
  'pages.dashboard.module.deviceInfo': 'Устройства: ОС и версии',
  'pages.dashboard.module.topDevicesUsers': 'Топ устройств и пользователей',
  'pages.dashboard.module.connectionQuality': 'Качество подключений',
  'pages.dashboard.module.hourlyPattern': 'Активность по часам',
  'pages.dashboard.module.geoDistribution': 'География',
  'pages.dashboard.module.uptime': 'Uptime устройств',
  'pages.dashboard.typeDistribution': 'Типы подключений',
  'pages.dashboard.connType.remote_control': 'Удалённое управление',
  'pages.dashboard.connType.file_transfer': 'Передача файлов',
  'pages.dashboard.connType.port_forward': 'Проброс портов',
  'pages.dashboard.connType.camera': 'Камера',
  'pages.dashboard.connType.terminal': 'Терминал',
  'pages.dashboard.connType.not_established': 'Не установлено',
  'pages.dashboard.connType.unknown': 'Неизвестно',
  'pages.dashboard.deviceInfoDistribution': 'Устройства по ОС и версии',
  'pages.dashboard.byOs': 'По ОС',
  'pages.dashboard.byVersion': 'По версии клиента',
  'pages.dashboard.outdatedHint': 'Ниже целевой версии',
  'pages.dashboard.outdatedVersion': 'устаревшие',
  'pages.dashboard.topDevicesUsers': 'Топ устройств и пользователей',
  'pages.dashboard.topDevices': 'Топ устройств',
  'pages.dashboard.topUsers': 'Топ пользователей',
  'pages.dashboard.connectionQuality': 'Качество подключений',
  'pages.dashboard.hourlyPattern': 'Активность по часам',
  'pages.dashboard.hourlyHint': 'за 30 дней',
  'pages.dashboard.geoDistribution': 'География',
  'pages.dashboard.geoLocation': 'Местоположение',
  'pages.dashboard.geoCountry': 'Страна',
  'pages.dashboard.geoShare': 'Доля',
  'pages.dashboard.geoDevices': 'Устройства',
  'pages.dashboard.geoConnections': 'Подключения',
  'pages.dashboard.geoEmpty': 'Нет данных о географии (локальная GeoIP-БД)',
  'pages.dashboard.deviceUptime': 'Uptime устройств',
  'pages.dashboard.uptime24h': '24 ч',
  'pages.dashboard.uptime7d': '7 дней',
  'pages.dashboard.uptimeEmpty':
    'Данные uptime собираются (снимки каждые 5 минут)',
  'pages.dashboard.deviceOnlineTrend': 'История онлайна устройств',
  'pages.dashboard.fileTransferTrend': 'Тренд передач файлов',
  'pages.smtp.title': 'Настройки SMTP',
  'pages.smtp.description':
    'Настройте SMTP-сервер для отправки системных уведомлений по email',
  'pages.smtp.host': 'Адрес сервера',
  'pages.smtp.hostPlaceholder': 'Введите адрес SMTP-сервера',
  'pages.smtp.port': 'Порт',
  'pages.smtp.portPlaceholder': 'Введите номер порта',
  'pages.smtp.secure': 'Использовать SSL/TLS',
  'pages.smtp.secureHelp':
    'Включить защищённое соединение (обычно порт 465 использует SSL, порт 587 использует TLS)',
  'pages.smtp.user': 'Имя пользователя',
  'pages.smtp.userPlaceholder': 'Введите имя пользователя для SMTP-аутентификации',
  'pages.smtp.password': 'Пароль',
  'pages.smtp.passwordPlaceholder': 'Введите пароль для SMTP-аутентификации',
  'pages.smtp.from': 'Email отправителя',
  'pages.smtp.fromPlaceholder': 'Введите email отправителя',
  'pages.smtp.enabled': 'Включить конфигурацию',
  'pages.smtp.enabledHelp':
    'При включении эта конфигурация будет использоваться для отправки системных писем',
  'pages.smtp.testConnection': 'Проверить подключение',
  'pages.smtp.testSuccess': 'Тест SMTP-подключения успешен',
  'pages.smtp.testFailed': 'Тест SMTP-подключения не удался',
  'pages.smtp.saveSuccess': 'Конфигурация SMTP успешно сохранена',
  'pages.smtp.saveFailed': 'Не удалось сохранить конфигурацию SMTP',
  'pages.smtp.createdAt': 'Создано в',
  'pages.smtp.updatedAt': 'Обновлено в',
  'pages.addressBook.color': 'Цвет',
  'pages.addressBook.deviceInfo': 'имя_пользователя@имя_устройства',
  'pages.addressBook.manageTags': 'Управление тегами',
  'pages.addressBook.newTagName': 'Новое имя тега',
  'pages.addressBook.peerUpdateFailed': 'Не удалось обновить контакт',
  'pages.addressBook.peerUpdated': 'Контакт обновлён',
  'pages.addressBook.renameTag': 'Переименовать тег',
  'pages.addressBook.selectTags': 'Выберите теги',
  'pages.addressBook.tagColorUpdateFailed': 'Не удалось обновить цвет тега',
  'pages.addressBook.tagRenameFailed': 'Не удалось переименовать тег',
  'pages.addressBook.tagRenamed': 'Тег переименован',
  'pages.addressBook.untagged': 'Без тега',
  'pages.common.cancel': 'Нет',
  'pages.common.confirm': 'Да',
  'pages.common.enterDescription': 'Введите описание',
  'pages.common.rename': 'Переименовать',
  'pages.common.save': 'Сохранить',
  'pages.customClients.enterName': 'Введите имя клиента',
  'pages.settings.chinese': 'Китайский',
  'pages.settings.english': 'Английский',
  'pages.settings.russian': 'Русский',
  'pages.settings.enterAdminEmail': 'Введите email администратора',
  'pages.settings.enterSiteName': 'Введите название сайта',
  'pages.settings.logError': 'Ошибка',
  'pages.settings.logInfo': 'Информация',
  'pages.settings.logWarning': 'Предупреждение',
  'pages.userGroups.enterName': 'Введите имя группы',
  'pages.users.admin': 'Администратор',
  'pages.users.me': 'Я',
  'pages.oidcProviders.list': 'Провайдеры OIDC',
  'pages.oidcProviders.sort': 'Сортировка',
  'pages.oidcProviders.name': 'Имя провайдера',
  'pages.oidcProviders.type': 'Тип',
  'pages.oidcProviders.issuer': 'URL эмитента',
  'pages.oidcProviders.clientId': 'ID клиента',
  'pages.oidcProviders.clientSecret': 'Секрет клиента',
  'pages.oidcProviders.scope': 'Область',
  'pages.oidcProviders.authorizationEndpoint': 'Конечная точка авторизации',
  'pages.oidcProviders.tokenEndpoint': 'Конечная точка токена',
  'pages.oidcProviders.userinfoEndpoint': 'Конечная точка информации',
  'pages.oidcProviders.jwksUri': 'URI JWKS',
  'pages.oidcProviders.enabled': 'Включён',
  'pages.oidcProviders.priority': 'Приоритет',
  'pages.oidcProviders.endpointConfig': 'Конфигурация конечных точек',
  'pages.oidcProviders.create': 'Создать провайдера',
  'pages.oidcProviders.edit': 'Редактировать провайдера',
  'pages.oidcProviders.test': 'Тест',
  'pages.oidcProviders.testResult': 'Результат теста подключения',
  'pages.oidcProviders.discoveredEndpoints': 'Обнаруженные конечные точки',
  'pages.oidcProviders.enterName': 'Введите имя провайдера',
  'pages.oidcProviders.enterIssuer': 'Введите URL эмитента',
  'pages.oidcProviders.enterClientId': 'Введите ID клиента',
  'pages.oidcProviders.enterClientSecret': 'Введите секрет клиента',
  'pages.oidcProviders.enterEndpoint': 'Авто-обнаружение, если пусто',
  'pages.oidcProviders.createSuccess': 'Провайдер OIDC создан',
  'pages.oidcProviders.createFailed': 'Не удалось создать провайдера OIDC',
  'pages.oidcProviders.updateSuccess': 'Провайдер OIDC обновлён',
  'pages.oidcProviders.updateFailed': 'Не удалось обновить провайдера OIDC',
  'pages.oidcProviders.deleteSuccess': 'Провайдер OIDC удалён',
  'pages.oidcProviders.deleteFailed': 'Не удалось удалить провайдера OIDC',
  'pages.oidcProviders.deleteConfirm': 'Вы уверены, что хотите удалить этого провайдера?',
  'pages.oidcProviders.enableSuccess': 'Провайдер OIDC включён',
  'pages.oidcProviders.enableFailed': 'Не удалось включить провайдера OIDC',
  'pages.oidcProviders.disableSuccess': 'Провайдер OIDC отключён',
  'pages.oidcProviders.disableFailed': 'Не удалось отключить провайдера OIDC',
  'pages.oidcProviders.enableConfirm': 'Вы уверены, что хотите включить этого провайдера?',
  'pages.oidcProviders.disableConfirm':
    'Вы уверены, что хотите отключить этого провайдера?',
  'pages.oidcProviders.testFailed': 'Не удалось проверить OIDC-подключение',
  'pages.oidcProviders.fetchDetailFailed': 'Не удалось получить детали провайдера',
  'pages.oidcProviders.sortFailed': 'Не удалось обновить порядок провайдеров',
  'pages.account.tab.basic': 'Основная информация',
  'pages.account.tab.avatar': 'Аватар',
  'pages.account.tab.security': 'Безопасность',
  'pages.account.basicInfo.title': 'Основная информация',
  'pages.account.basicInfo.displayName': 'Отображаемое имя',
  'pages.account.basicInfo.displayNamePlaceholder': 'Введите отображаемое имя',
  'pages.account.basicInfo.name': 'Имя пользователя',
  'pages.account.basicInfo.email': 'Email',
  'pages.account.basicInfo.note': 'Примечание',
  'pages.account.basicInfo.updateSuccess': 'Профиль успешно обновлён',
  'pages.account.basicInfo.updateFailed': 'Не удалось обновить профиль',
  'pages.account.avatar.title': 'Настройки аватара',
  'pages.account.avatar.hint':
    'Поддерживаются JPG, PNG, WebP, макс. 2 МБ, будет изменён до 256x256',
  'pages.account.avatar.upload': 'Загрузить аватар',
  'pages.account.avatar.delete': 'Удалить аватар',
  'pages.account.avatar.deleteConfirm': 'Вы уверены, что хотите удалить аватар?',
  'pages.account.avatar.uploadSuccess': 'Аватар успешно загружен',
  'pages.account.avatar.uploadFailed': 'Не удалось загрузить аватар',
  'pages.account.avatar.deleteSuccess': 'Аватар успешно удалён',
  'pages.account.avatar.deleteFailed': 'Не удалось удалить аватар',
  'pages.account.avatar.fileTooLarge': 'Размер файла не может превышать 2 МБ',
  'pages.account.avatar.invalidFormat':
    'Поддерживаются только форматы JPG, PNG, WebP',
  'pages.account.security.title': 'Настройки безопасности',
  'pages.account.security.2faStatus': 'Статус 2FA',
  'pages.account.security.2faAction': 'Действие',
  'pages.account.security.enabled': 'Включено',
  'pages.account.security.disabled': 'Отключено',
  'pages.account.security.enable2FA': 'Включить 2FA',
  'pages.account.security.disable2FA': 'Отключить 2FA',
  'pages.account.security.setup2FA': 'Настройка двухфакторной аутентификации',
  'pages.account.security.setupFailed': 'Не удалось настроить 2FA',
  'pages.account.security.scanQRCode':
    'Отсканируйте QR-код в приложении-аутентификаторе, затем введите код подтверждения ниже.',
  'pages.account.security.secretKey': 'Секретный ключ',
  'pages.account.security.verificationCode': 'Код подтверждения',
  'pages.account.security.enterCode': 'Пожалуйста, введите код подтверждения',
  'pages.account.security.verifyAndEnable': 'Подтвердить и включить',
  'pages.account.security.enableSuccess': '2FA успешно включена',
  'pages.account.security.enableFailed': 'Не удалось включить 2FA',
  'pages.account.security.currentCode': 'Текущий код подтверждения',
  'pages.account.security.confirmDisable': 'Подтвердить отключение',
  'pages.account.security.disableSuccess': '2FA успешно отключена',
  'pages.account.security.disableFailed': 'Не удалось отключить 2FA',
  'pages.account.security.password': 'Пароль для входа',
  'pages.account.security.passwordSet': 'Установлен',
  'pages.account.security.passwordNotSet': 'Не установлен',
  'pages.account.security.changePassword': 'Сменить пароль',
  'pages.account.security.currentPassword': 'Текущий пароль',
  'pages.account.security.enterCurrentPassword':
    'Пожалуйста, введите текущий пароль',
  'pages.account.security.newPassword': 'Новый пароль',
  'pages.account.security.enterNewPassword':
    'Пожалуйста, введите новый пароль (мин. 6 символов)',
  'pages.account.security.confirmNewPassword': 'Подтвердите новый пароль',
  'pages.account.security.confirmNewPasswordPlaceholder':
    'Пожалуйста, повторите новый пароль',
  'pages.account.security.passwordMinLength':
    'Пароль должен содержать не менее 6 символов',
  'pages.account.security.passwordMismatch': 'Пароли не совпадают',
  'pages.account.security.changePasswordSuccess':
    'Пароль успешно изменён',
  'pages.account.security.changePasswordFailed': 'Не удалось изменить пароль',
  'pages.account.security.thirdPartyUser':
    'Пользователи стороннего входа не могут сменить пароль',
  'pages.account.security.noPasswordUser': 'Для этого аккаунта не установлен пароль',
  'pages.account.security.passkey.title': 'Управление Passkey',
  'pages.account.security.passkey.register': 'Зарегистрировать Passkey',
  'pages.account.security.passkey.registerSuccess':
    'Passkey успешно зарегистрирован',
  'pages.account.security.passkey.registerFailed': 'Не удалось зарегистрировать Passkey',
  'pages.account.security.passkey.deleteSuccess':
    'Passkey успешно удалён',
  'pages.account.security.passkey.deleteFailed': 'Не удалось удалить Passkey',
  'pages.account.security.passkey.deleteConfirm':
    'Вы уверены, что хотите удалить этот Passkey?',
  'pages.account.security.passkey.name': 'Имя',
  'pages.account.security.passkey.namePlaceholder': 'например, MacBook Touch ID',
  'pages.account.security.passkey.namePasskey': 'Назовите ваш Passkey',
  'pages.account.security.passkey.deviceType': 'Тип устройства',
  'pages.account.security.passkey.multiDevice': 'Несколько устройств',
  'pages.account.security.passkey.singleDevice': 'Одно устройство',
  'pages.account.security.passkey.createdAt': 'Создан в',
  'pages.account.security.passkey.noCredentials': 'Passkey не зарегистрированы',
  'pages.account.security.sessions.title': 'Сессии входа',
  'pages.account.security.sessions.device': 'Устройство',
  'pages.account.security.sessions.type': 'Тип',
  'pages.account.security.sessions.browser': 'Браузер',
  'pages.account.security.sessions.client': 'Клиент',
  'pages.account.security.sessions.os': 'ОС',
  'pages.account.security.sessions.createdAt': 'Создана в',
  'pages.account.security.sessions.expiresAt': 'Истекает в',
  'pages.account.security.sessions.current': 'Текущая',
  'pages.account.security.sessions.revoke': 'Отозвать',
  'pages.account.security.sessions.revokeConfirm':
    'Вы уверены, что хотите отозвать эту сессию?',
  'pages.account.security.sessions.revokeSuccess':
    'Сессия успешно отозвана',
  'pages.account.security.sessions.revokeFailed': 'Не удалось отозвать сессию',
  'pages.account.security.sessions.cannotRevokeCurrent':
    'Невозможно отозвать текущую сессию',
  'pages.account.security.sessions.noSessions': 'Нет активных сессий',
  'pages.ldap.title': 'Конфигурация LDAP',
  'pages.ldap.description':
    'Настройте аутентификацию LDAP/Active Directory. При включении пользователи будут автоматически аутентифицироваться через LDAP.',
  'pages.ldap.urls': 'URL серверов',
  'pages.ldap.urlsRequired': 'Введите хотя бы один URL LDAP-сервера',
  'pages.ldap.urlPlaceholder': 'например, ldaps://ad.example.com:636',
  'pages.ldap.addUrl': 'Добавить URL сервера',
  'pages.ldap.bindDN': 'Bind DN',
  'pages.ldap.bindDNRequired': 'Введите Bind DN сервисного аккаунта',
  'pages.ldap.bindDNPlaceholder':
    'например, CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Пароль привязки',
  'pages.ldap.bindCredentialsRequired':
    'Введите пароль сервисного аккаунта',
  'pages.ldap.bindCredentialsPlaceholder':
    'Введите пароль сервисного аккаунта',
  'pages.ldap.searchBase': 'Базовый DN поиска',
  'pages.ldap.searchBaseRequired': 'Введите базовый DN поиска',
  'pages.ldap.searchBasePlaceholder': 'например, DC=example,DC=com',
  'pages.ldap.searchFilter': 'Фильтр поиска',
  'pages.ldap.searchFilterRequired': 'Введите фильтр поиска',
  'pages.ldap.searchFilterHelp':
    'Используйте {{username}} как placeholder для имени пользователя. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': 'например, (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Атрибуты поиска',
  'pages.ldap.searchAttributePlaceholder':
    'например, dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Добавить атрибут',
  'pages.ldap.groupSearchBase': 'Базовый DN поиска групп',
  'pages.ldap.groupSearchBasePlaceholder': 'например, OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Фильтр поиска групп',
  'pages.ldap.groupSearchFilterHelp':
    'Используйте {{dn}} как placeholder DN пользователя. например, (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'например, (member={{dn}})',
  'pages.ldap.adminGroups': 'Группы администраторов',
  'pages.ldap.adminGroupsHelp':
    'Пользователи из этих групп LDAP будут отображаться как администраторы (регистронезависимое совпадение)',
  'pages.ldap.adminGroupPlaceholder':
    'например, CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Добавить группу администраторов',
  'pages.ldap.tlsOptions': 'Параметры TLS',
  'pages.ldap.tlsCa': 'CA сертификат (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Клиентский сертификат (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Приватный ключ клиента (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'SNI имя сервера',
  'pages.ldap.tlsServernamePlaceholder': 'Server Name Indication для TLS',
  'pages.ldap.enabled': 'Включить аутентификацию LDAP',
  'pages.ldap.enabledHelp':
    'При включении пользователи будут аутентифицироваться через LDAP-сервер. Существующие пользователи, связанные с LDAP, всегда будут использовать аутентификацию LDAP независимо от этого параметра.',
  'pages.ldap.testConnection': 'Проверить подключение',
  'pages.ldap.testSuccess': 'Тест LDAP-подключения успешен',
  'pages.ldap.testFailed': 'Тест LDAP-подключения не удался',
  'pages.ldap.saveSuccess': 'Конфигурация LDAP успешно сохранена',
  'pages.ldap.saveFailed': 'Не удалось сохранить конфигурацию LDAP',
  'pages.ldap.createdAt': 'Создано в',
  'pages.ldap.updatedAt': 'Обновлено в',
  'pages.nexus.repoRequired': 'Требуется взаимодействие с репозиторием',
  'pages.nexus.repoRequiredDesc':
    'Вам нужно поставить Star, Fork или Watch на репозиторий databk/rustdesk-console на GitHub перед созданием пользовательских клиентов. Обновление кэша может занять до 5 минут.',
  'pages.nexus.goToRepo': 'Перейти к репозиторию GitHub',
  'pages.nexus.buildList': 'История сборок',
  'pages.nexus.createBuild': 'Создать новый клиент',
  'pages.nexus.noBuilds': 'Нет записей сборок',
  'pages.nexus.createBuildTitle': 'Создать пользовательского клиента',
  'pages.nexus.customConfig': 'Пользовательская конфигурация',
  'pages.nexus.serverConfig': 'Конфигурация сервера',
  'pages.nexus.password': 'Пароль',
  'pages.nexus.passwordPlaceholder': 'Введите пароль',
  'pages.nexus.salt': 'Соль',
  'pages.nexus.saltPlaceholder': 'Введите соль',
  'pages.nexus.connType': 'Тип подключения',
  'pages.nexus.disableInstallation': 'Отключить установку',
  'pages.nexus.disableSettings': 'Отключить настройки',
  'pages.nexus.disableAccount': 'Отключить аккаунт',
  'pages.nexus.disableAb': 'Отключить адресную книгу',
  'pages.nexus.disableTcpListen': 'Отключить TCP прослушивание',
  'pages.nexus.rendezvousServer': 'ID сервер',
  'pages.nexus.relayServer': 'Ретранслятор',
  'pages.nexus.key': 'Ключ',
  'pages.nexus.apiServer': 'API сервер',
  'pages.nexus.overrideSettings': 'Переопределить настройки',
  'pages.nexus.defaultSettings': 'Настройки по умолчанию',
  'pages.nexus.settingType': 'Тип настройки',
  'pages.nexus.deleteBuildConfirm':
    'Вы уверены, что хотите удалить эту запись сборки?',
  'pages.nexus.deleteSuccess': 'Запись сборки удалена',
  'pages.nexus.deleteFailed': 'Не удалось удалить запись сборки',
  'pages.nexus.pollingBuildStatus': 'Опрос статуса сборки...',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.concurrentLimit': 'Только одна сборка за раз',
  'pages.nexus.os': 'Операционная система',
  'pages.nexus.arch': 'Архитектура',
  'pages.nexus.appName': 'Имя приложения',
  'pages.nexus.enterAppName': 'Пожалуйста, введите имя приложения',
  'pages.nexus.appNamePlaceholder': 'например, my-rustdesk',
  'pages.nexus.appNameHint': 'Допускаются только английские буквы',
  'pages.nexus.submitBuild': 'Отправить сборку',
  'pages.nexus.bindSuccess': 'Аккаунт GitHub успешно привязан',
  'pages.nexus.bindFailed': 'Не удалось привязать аккаунт GitHub',
  'pages.nexus.createLoginFailed': 'Не удалось создать сессию входа',
  'pages.nexus.unbindConfirm': 'Отвязать аккаунт GitHub',
  'pages.nexus.unbindConfirmContent':
    'Вы уверены, что хотите отвязать аккаунт GitHub? Вам нужно будет повторно привязать его для создания пользовательских клиентов.',
  'pages.nexus.unbindSuccess': 'Аккаунт GitHub отвязан',
  'pages.nexus.unbindFailed': 'Не удалось отвязать аккаунт GitHub',
  'pages.nexus.tokenExpired': 'Срок действия токена GitHub истёк',
  'pages.nexus.tokenExpiredDesc':
    'Срок действия токена GitHub для {username} истёк. Пожалуйста, повторно привяжите аккаунт.',
  'pages.nexus.rebind': 'Повторно привязать аккаунт GitHub',
  'pages.nexus.bindTitle': 'Привязка аккаунта GitHub',
  'pages.nexus.bindDesc':
    'Вам нужно привязать аккаунт GitHub для создания пользовательских клиентов. Нажмите кнопку ниже для авторизации через GitHub.',
  'pages.nexus.bindGithub': 'Авторизоваться через GitHub',
  'pages.nexus.unbind': 'Отвязать',
  'pages.nexus.repoInteractionRequired':
    'Пожалуйста, поставьте Star, Fork или Watch на репозиторий databk/rustdesk-console на GitHub. Обновление кэша может занять до 5 минут.',
  'pages.nexus.buildAlreadyRunning': 'У вас уже есть выполняющаяся сборка',
  'pages.nexus.generateFailed': 'Не удалось отправить запрос на сборку',
  'pages.nexus.downloadFailed': 'Не удалось скачать пользовательского клиента',
  'pages.nexus.download': 'Скачать',
  'pages.nexus.buildAgain': 'Собрать снова',
  'pages.nexus.status': 'Статус',
  'pages.nexus.statusPending': 'Сборка ожидает',
  'pages.nexus.statusPendingDesc':
    'Ваш запрос на сборку отправлен и ожидает обработки...',
  'pages.nexus.statusBuilding': 'Сборка',
  'pages.nexus.statusBuildingDesc':
    'GitHub Actions собирает вашего клиента. Это может занять несколько минут...',
  'pages.nexus.statusCompleted': 'Сборка завершена',
  'pages.nexus.statusCompletedDesc':
    'Ваш пользовательский клиент готов к скачиванию.',
  'pages.nexus.statusFailed': 'Сборка не удалась',
  'pages.nexus.statusFailedDesc': 'В процессе сборки произошла ошибка.',
  'pages.nexus.statusCancelled': 'Сборка отменена',
  'pages.nexus.statusCancelledDesc':
    'Сборка была отменена, обычно из-за удаления Star/Fork репозитория.',
  'pages.nexus.bindWhyLogin':
    'Аутентификация GitHub помогает нам убедиться, что вы реальный пользователь, предотвращая автоматическое злоупотребление ресурсами сборки. Мы запрашиваем только ваши публичные данные — без доступа к вашим репозиториям, личным данным или любым другим разрешениям.',
  'pages.nexus.repoWhyInteract':
    'Я школьник, разрабатывающий этот проект в свободное время. Ваши Star, Fork или Watch много значат для меня — это не только мотивирует меня, но и помогает с поступлением в университет. Это единственное, что я прошу взамен. Большое спасибо за вашу поддержку!',
  'pages.health.title': 'Здоровье системы',
  'pages.health.cpu': 'CPU',
  'pages.health.memory': 'Память',
  'pages.health.disk': 'Диск',
  'pages.health.services': 'Сервисы',
  'pages.health.containers': 'Контейнеры',
  'pages.health.ssl': 'SSL-сертификат',
  'pages.health.domain': 'Домен',
  'pages.health.issuer': 'Издатель',
  'pages.health.expires': 'Истекает',
  'pages.health.daysLeft': 'Дней до истечения',
  'pages.health.database': 'База данных',
  'pages.health.dbSize': 'Размер',
  'pages.health.peersTotal': 'Устройств всего',
  'pages.health.peersOnline': 'Устройств онлайн',
  'pages.health.hostname': 'Хост',
  'pages.health.uptime': 'Аптайм',
  'pages.health.lastUpdate': 'Обновлено',
  'pages.health.fetchFailed': 'Не удалось получить данные о здоровье системы',
  'pages.health.hostUnavailable': 'Данные о сервере недоступны. Проверьте выполнение health-check.sh на хосте.',
};
